(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["diashark-size-group"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('diashark-size-group')) {
    customElements.define('diashark-size-group', class extends HTMLElement {
      connectedCallback() {
        const url = new URL(window.location.href);
        const sourceVariant = url.searchParams.get('variant');
        if (!sourceVariant) return;
        const data = this.querySelector('[data-legacy-size-variants]');
        if (!data) return;
        let mapping;
        try { mapping = JSON.parse(data.textContent); } catch { return; }
        const target = mapping?.[sourceVariant];
        if (!target || String(target.product_id) === this.dataset.productId) return;
        if (!/^[a-z0-9-]+$/.test(target.handle) || !/^\d+$/.test(String(target.variant_id))) return;
        url.pathname = `${this.dataset.rootUrl}products/${target.handle}`;
        url.searchParams.set('variant', target.variant_id);
        window.location.replace(url.href);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
